"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/Seminars.scss");
require("./modules/seminars-list");
require("./modules/seminars-detail");
require("./modules/legacy/seminars/seminars");
exports.default = {};
